export enum TYPE_ANALYSIS_ALFATOTAL {
  GROSS_SEPARATION = 1,
  FINE_SEPARATION = 2,
}

export const TYPE_SR = [
  {
    value: TYPE_ANALYSIS_ALFATOTAL.GROSS_SEPARATION,
    label: "Separación gruesa",
  },
  { value: TYPE_ANALYSIS_ALFATOTAL.FINE_SEPARATION, label: "Separación fina" },
];

export const SR_ISOTOPES = {
  SR89: {
    simbol: "Sr89",
    key: "sr89_cdes",
    label: "Cte. Desintegración λSr89(min-1)",
  },
  SR90: {
    simbol: "Sr90",
    key: "sr90_cdes",
    label: "Cte. Desintegración λSr90(min-1)",
  },
  Y90: {
    simbol: "Y90",
    key: "y90_cdes",
    label: "Cte. Desintegración λY90(min-1)",
  },
};
